export default Object.freeze({
    //Vue側で使用const

    // メニュー項目
    MENU_HOME: 0,
    MENU_ANALYSIS: 1,
    MENU_PROJECT: 2,
    MENU_ACCOUNT: 3,
    MENU_PAYMENT: 4,
    MENU_ADMIN: 5,

    // i18n複数形対応
    I18N_SIINGULAR: 1,
    I18N_PURAL: 2,

    // 0:アクティベート未来日（日づけ表示）,　1:アクティベート,　2:アクティベート（期限切れ近い), 3:未アクティベート
    ACTIVATE_FUTURE: 0,
    ACTIVATE_TRUE: 1,
    ACTIVATE_EXPIRATION_IMMEDIATELY: 2,
    ACTIVATE_FALSE: 3,

    // QRT作成画面STEP項目
    EDITQRT_STEP_CODEINFO: 1,
    EDITQRT_STEP_EDITDOC: 2,
    EDITQRT_STEP_TRANSFER: 3,
    EDITQRT_STEP_COMPLETE: 4,

    // QRTオプション作成画面STEP項目
    EDITQRT_OPTION_STEP_CODEINFO: 1,
    EDITQRT_OPTION_STEP_EDIT_TESTING: 2,
    EDITQRT_OPTION_STEP_QRCODE: 3,

    // アクセス統計画面 アコーディオンパネル項目
    ACCESS_ANALYSIS_PANEL_RANGE:0,
    ACCESS_ANALYSIS_PANEL_MAP:1,
    ACCESS_ANALYSIS_PANEL_GRAPH:2,

    // 言語API信頼値(gogole apiが検出した言語の信頼度 MAX=1)
    LANG_CONFIDENCE_NUM: 0.6,

    // 翻訳言語最大数
    QRCREATE_LANG_MAX: 14,

    // QRコード　保存形式
    QRTCODE_SAVETYPE_PNG : "png",
    QRTCODE_SAVETYPE_SVG : "svg",

    // QRコード色設定　カラーパレット
    QRTCODE_COLOR_PALETTE1 : [
        ['#E60012', '#920783', '#550000'],
        ['#E4770F', '#E4007F', '#555500'],
        ['#224400', '#530000', '#005500'],
        ['#009944', '#001A43', '#005555'],
        ['#1D2088', '#000030', '#000000']
    ],
    
    QRTCODE_COLOR_PALETTE2 :  [
        ['#FFBBDD', '#DDEEEE', '#EEEEEE'],
        ['#FFBBBB', '#99DDFF', '#E5E5E5'],
        ['#FFFFBB', '#DDDDFF', '#E0D0A0'],
        ['#DDEEAA', '#FADCE9', '#FBDAC8'],
        ['#BAFFDD', '#FADBDA', '#FFFFFF']
    ],

    // グラフカラー
    GRAPH_COLOR: [
        [0x33, 0x66, 0xcc, 1, "blue"  ],   //青
        [0x0a, 0x90, 0x5d, 1, "green" ],   //緑
        [0x8c, 0xbd, 0x3f, 1, "olive" ],   //オリーブ
        [0xfd, 0xc7, 0x0f, 1, "yellow"],   //黄色
        [0xf2, 0x8f, 0x1f, 1, "orange"],   //オレンジ
        [0xe4, 0x24, 0x26, 1, "red"   ],   //赤
        [0xcb, 0x61, 0x96, 1, "pink"  ],   //ピンク
        [0x99, 0x66, 0x99, 1, "violet"],   //紫
        // 上記の透明度85%（黒背景）
        [0x29, 0x52, 0xa3, 1, "blue2"  ],   //青2
        [0x08, 0x73, 0x4a, 1, "green2" ],   //緑2
        [0x70, 0x97, 0x32, 1, "olive2" ],   //オリーブ2
        [0xca, 0x9f, 0x0c, 1, "yellow2"],   //黄色2
        [0xc2, 0x72, 0x19, 1, "orange2"],   //オレンジ2
        [0xb6, 0x1d, 0x1e, 1, "red2"   ],   //赤2
        [0xa2, 0x4e, 0x78, 1, "pink2"  ],   //ピンク2
        [0x7a, 0x52, 0x7a, 1, "violet2"]    //紫2
    ],
    
    // QRコード生成オプション値
    EDITQRT_ERROR_CORRECTION: 'Q',
    EDITQRT_MARGIN1: 4,
    EDITQRT_MARGIN2: 2,
    EDITQRT_EYE_COLOR: '255,255,255,100',

    // 時系列グラフ用　Unitデータ
    GRAPH_UNIT_INFO: [
        {text:"時",  value:"hour"},
        {text:"日",  value:"day"},
        {text:"月",  value:"month"}
    ],
    
    // グラフ用 並び順
    GRAPH_SORT: [
        {text:"ビュー数多い順",  value:"view"},
        {text:"コード順",  value:"code"}
    ],

    // グラフ用 集計単位
    GRAPH_COLLECTION: [
        {text:"時間帯",  value:"hour"},
        {text:"曜日",  value:"week"}
    ],

    // OS/ブラウザグラフ用 集計単位
    GRAPH_OS_BROWSER_COLLECTION: [
        {text:"OS別",  value:"operatingSystem"},
        {text:"ブラウザ別",  value:"browser"}
    ],

    // グラフ凡例のMAX値（MAX値以上のものはその他にまとめられる）
    GRAPH_MAX_LEGEND: 16,

    // SNS表示非表示
    SNS_DISPLAY: 1,
    SNS_NON_DISPLAY: 0,

    // localStorageキー
    // コードリスト非表示カラム
    LOCAL_STORAGE_CODELIST_HIDDENCOLUMNS: 'codeList.hiddenColumns',
    LOCAL_STORAGE_CODELIST_SORTBY: 'codeList.sortBy',
    LOCAL_STORAGE_CODELIST_SORTDESC: 'codeList.sortDesc',
    // 管理者コード リスト非表示カラム
    // QRCode一覧
    LOCAL_STORAGE_ADMIN_CODELIST_HIDDENCOLUMNS: 'adminCodeList.hiddenColumns',
    LOCAL_STORAGE_ADMIN_CODELIST_DRAFT: 'adminCodeList.draft',
    // Project一覧
    LOCAL_STORAGE_ADMIN_PROJECTLIST_HIDDENCOLUMNS: 'adminProjectList.hiddenColumns',
    // 管理者コード アカウント非表示カラム
    LOCAL_STORAGE_ADMIN_ACCOUNTLIST_HIDDENCOLUMNS: 'adminAccountList.hiddenColumns',
    // 管理者ログインリスト　スタッフ表示
    LOCAL_STORAGE_ADMIN_LOGINLIST_ADMIN: 'adminLoginList.admin',
    // Guide表示タブ
    LOCAL_STORAGE_USER_GUIDE_TAB: 'userGuide.selectTab',

    // Project情報保持(再度ブラウザを開いたときに前回のProjectを選択させる)
    LOCAL_STORAGE_SELECTED_PROJECT_ID: 'selected.projectid',

    // httpから始まるurlの最大長
    /** https://qiita.com/pro_matuzaki/items/70fb639f7ed7463f9943 */
    URL_MAX_LENGTH: 8000,

    // アクティベートサイクル単位
    ACTIVATE_CYCLE: [
        {text:"日",  value:"d"},
        {text:"カ月",  value:"m"},
        {text:"年",  value:"y"} // デフォルト
    ],
    
    // アクティベートサイクルデフォルト値(1year)
    ACTIVATE_DEFAULT_PRRIOD_UNIT: "y",
    ACTIVATE_DEFAULT_PRRIOD_VAL: 1,

    // Microsoft音声ストリーミングのFormat
    // Audio24Khz48KBitRateMonoMp3 = 6	audio-24khz-48kbitrate-mono-mp3
    MICROSOFT_SPEECHSDK_FORMAT: 6,
    
    // カスタム言語登録MAX数
    MAX_CUSTOM_LANGUAGE: 50,

    // 権限設定画面
    // 言語設定(すべて設定時)
    SET_MEMBER_AUTH_EDIT_LANG_ALL: 'all',

    // Projectメンバー招待時の方法設定
    PROJECT_MEMBER_INVITED_BY_ACCOUNTNAME: 'account',
    PROJECT_MEMBER_INVITED_BY_MAIL: 'email',
    
    // 通知表示最大数
    PUSHER_LOG_VIEW_MAX: 25,

    // TOAST表示位置
    TOAST_SETTING: {
      position: "bottom-right",
      duration : 2000,
	  	className: ['toasting']
    },

    TOAST_DRAFT_SAVE_MSG: "Draft saved",
    TOAST_SAVE_MSG: "Saved",

    // LaravelCasherのURL
    STRIPE_PAYMENT_URL: 'stripe/payment/'
    
});